<template>
  <default-dialog @input="closeForm()" :value="enabled" :title="`${imageDescription ? 'Editar' : 'Adicionar'} descrição`">
    <template v-if="$vuetify.breakpoint.name !== 'xs'" slot="rightButton">
      <v-btn @click="submit" text>Salvar</v-btn>
    </template>
    <template v-else slot="actions">
      <v-spacer/>
      <v-btn dark color="primary" @click="submit">Salvar</v-btn>
    </template>
    <v-form ref="form" v-model="valid" style="margin-top: 19px;">
      <v-textarea
        v-model="description"
        auto-grow
        xs12
        :rules="[formRules.description]"
        :counter="maxLength"
        :label="'Descrição'"
        :placeholder="'Descreva a imagem'"
        :hide-details="'auto'"
        :color="'primary'"
        :rows="'1'"
      />
    </v-form>


  </default-dialog>
</template>

<script>
import FormRules from "@/utils/formRules.js";
import { maxLength } from "@/utils/maxLength";
import DefaultDialog from "@/components/dialogs/Default";

export default {
  mixins: [FormRules],
  components: { DefaultDialog },
  props: {
    imageDescription: { required: true, type: String },
    enabled: { required: true, type: Boolean }
  },

  mounted() {
    this.description = this.imageDescription
  },
  data: () => ({
    maxLength: maxLength.description,
    valid: true,
    description: '',
  }),

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    closeForm() {
      this.reset();
      this.$emit("closed");
    },
    submit() {
      this.validate();      
      if (this.valid) {
        this.$emit("submit", this.description);
        this.closeForm();
      }
    }
  }
};
</script>